import { FunctionComponent } from "react";
import ListFilterButton from "components/shared/ListFilterButton";

export interface SolarButtonProps {
  active: boolean;
  toggleValue: (key: string) => void;
}

const SolarButton: FunctionComponent<SolarButtonProps> = function ({
  active,
  toggleValue,
}) {
  return (
    <ListFilterButton
      id="solar"
      active={active}
      label="Solar jobs"
      activeLabel="Non-solar jobs"
      onClick={() => {
        toggleValue("solar");
      }}
    />
  );
};

export default SolarButton;
